import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51675606"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pending-entry-orders-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, /*#__PURE__*/_toDisplayString('Ordens pendentes de entrada'), -1))
const _hoisted_3 = {
  key: 1,
  class: "chart-group-legends"
}
const _hoisted_4 = { class: "chart-legends" }
const _hoisted_5 = { class: "chart-legends-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_VChart = _resolveComponent("VChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.label, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "chart-legends-item"
              }, [
                _createElementVNode("span", {
                  class: "chart-legends-color",
                  style: _normalizeStyle({ background: _ctx.colors[index] || _ctx.defaultColor })
                }, null, 4),
                _createElementVNode("p", _hoisted_5, _toDisplayString(item), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_VChart, {
          key: 2,
          id: "billed-chart",
          class: "chart",
          option: _ctx.options,
          autoresize: ""
        }, null, 8, ["option"]))
      : _createCommentVNode("", true)
  ]))
}